<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 mb-4">
        <vx-card title="Filtros">
          <div class="vx-row">
            <div class="vx-col w-1/2">
              <vs-input color="success" style="width: 100%" label-placeholder="Criterios de búsqueda: PID, ALIAS" v-model="term" @keyup.enter="_findProjects()"/>
            </div>
            <div class="vx-col w-1/2">
              <vs-select class="w-full" v-model="mutableFilters['projects.status']" name="filter_status" id="filter_status" multiple>
                <vs-select-item :key="s.value" v-for="s in revisionStatus" :value="s.value" :text="s.text">
                </vs-select-item>
              </vs-select>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="col-md-12">
        <vx-card title="Revisión de solicitudes">
          <vs-table ref="table" stripe pagination @dblSelection="handleDblSelected" search
            :max-items="itemsPerPage" :data="projects" noDataText="No se encontraron resultados">
            <div slot="header" class="ml-4 mt-2 mb-4 flex items-center flex-grow justify-left">

              <span class="ml-2 mr-4">Mostrando {{
              currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{
                projects.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : projects.length
                }} de <strong>{{ projects.length }}</strong> </span>

              <vs-dropdown v-if="isMounted" vs-trigger-click class="cursor-pointer ml-4 items-per-page-handler">
                <div
                  class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center font-medium">
                  <span class="mr-2 text-sm">Regs. por página: {{ itemsPerPage }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-5 w-5" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item v-for="it in itemsPerPageDefinitions" @click="updateItemsPerPage(it)" :key="it">
                    <span>{{ it }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>

              <div class="ml-6">
                <vs-button size="large" color="success" icon="refresh" @click="refreshTable()"></vs-button>
              </div>

              <div class="ml-6">
                <vx-tooltip title="Notas" color="primary" style="cursor:pointer" position="top"
                  text="Click sobre ID de proyecto para abrir detalle en un nuevo tab. Doble click sobre la fila para abrir en este tab.">
                  <vs-chip color="primary">?</vs-chip>
                </vx-tooltip>
              </div>

            </div>

            <template slot="thead">
              <vs-th class="bold" sort-key="id">ID</vs-th>
              <vs-th class="bold" sort-key="type">TIPO</vs-th>
              <vs-th class="bold" sort-key="client">CLIENTE</vs-th>
              <vs-th class="bold" sort-key="client">EJECUTIVO DE ORIGINACIÓN</vs-th>
              <vs-th class="bold" sort-key="client">EJECUTIVO DE RIESGO</vs-th>
              <!-- <vs-th class="bold" sort-key="tradename">PROVEEDOR</vs-th> -->
              <vs-th class="bold" sort-key="status">NO. DE REBOTES</vs-th>
              <vs-th class="bold" sort-key="status">ESTATUS</vs-th>
              <vs-th class="bold" sort-key="status">FECHAS</vs-th>
              <vs-th class="bold" sort-key="tt">TT (DÍAS)</vs-th>
              <vs-th class="bold" sort-key="light">SEM.</vs-th>
              <vs-th class="bold" sort-key="light">ACCIONES</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                <vs-td>
                  <vs-button size="small" type="line" @click="handleSelected(tr)">{{ tr.id }}</vs-button>
                </vs-td>
                <vs-td>
                  <vs-chip :color="clientTypeColor(tr.type)" class="extended">
                    <strong>{{ tr.type }}</strong>
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <strong>{{ tr.client }}</strong><br>
                  <strong>Producto: <span class="colored">{{ translateLoanType(tr.loan_type) }}</span><br></strong>
                  Onboarding step: <span class="colored">{{ tr.loan_request_step||"--" }}</span><br>
                  Tel: <span class="colored">{{ tr.phone }}</span><br>
                  Correo: <span class="colored">{{ tr.email }}</span><br>
                  <div  class="clickable" @click.stop="currentLead = tr.pgmApplicant, popupActivo = true">
                    <vs-chip v-if="tr.pgmApplicant" color="#f44336">
                      <strong>{{ tr.pgmApplicant.program_info.name }}</strong>
                    </vs-chip>
                  </div>
                </vs-td>
                <!-- <vs-td>
                  <template v-if="tr.sid">
                    <strong>{{ tr.sid }} | {{ tr.tradename }}</strong> <br>
                    <div class="clickable" @click="showSupplierInformation(tr.sid)">
                      <vs-chip transparent color="warning">
                          <span class="bold text-xs">Ver informacion del proveedor</span>
                      </vs-chip>
                    </div> <br>
                    <supplier-agent-information :projectId="tr.id"></supplier-agent-information>
                  </template>
                  <div v-else>
                    <p>Sin proveedor</p>
                  </div>
                </vs-td> -->
                <vs-td>{{ tr.origination_responsible || '--' }}</vs-td>
                <vs-td>{{ tr.credit_risk_responsible || '--' }}</vs-td>
                <vs-td>{{ (tr.credit_request_events)|| 0 }}</vs-td>
                <vs-td>
                  <vs-chip :color="statusColor(tr.status)">
                    <strong>{{ tr.statusStr }}</strong>
                  </vs-chip>
                  <br>
                  <vs-chip :color="statusColor(tr.status)">
                    <strong>{{ tr.case.toUpperCase() }}</strong>
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <!-- <span class="bold">Revisión sin documentos: <br></span>{{ sessionFormat(tr.loan_review_request_timestamp) }}  <br>
                  <span class="bold">Revisión con documentos: <br></span>{{ sessionFormat(tr.documentation_complete_date) }} <br> -->
                  <!-- <span class="bold">Oferta realizada: <br></span>{{ sessionFormat(tr.loan_proposal_timestamp) }} <br> -->
                  <span class="bold">Enviado a preaprobación: <br></span>{{ sessionFormat(tr.review_date) }} <br>
                  <span class="bold">Oferta aceptada: <br></span>{{ sessionFormat(tr.credit_acceptance_date) }} <br>
                  <span class="bold">Revisión orig.: <br></span>{{ sessionFormat(tr.application_screened_at) }} 
                </vs-td>
                <vs-td>{{ tr.tt }}</vs-td>
                <vs-td>
                  <div class="light" :class="`l-${tr.light}`"></div>
                </vs-td>
                <vs-td>
                  <LoanScreenedButton :loanId="tr.id" :isScreened="false" @on-save="_findProjects"></LoanScreenedButton>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <br><br><br>
        </vx-card>
      </div>
    </div>

    <!-- INFORMACIÓN DE PROGRAMA -->
    <vs-popup v-if="currentLead" class="mid-popup header-primary" title="Detalle del lead de programa" :active.sync="popupActivo">
      <vx-card>
        <h3>Información</h3>
        <div class="vx-row">
          <div class="vx-col w-full">
            <p class="bold">Cliente: </p> <span>{{ currentLead.customer_uid }} | {{ currentLead.customer_name }}</span> <br>
            <p class="bold">Zona | Región: </p> <span> {{ getZone(currentLead) }} | {{ getRegion(currentLead) }}</span> <br>
          </div>
        </div>
      </vx-card>
    </vs-popup>

    <!-- SUPPLIER INFORMATION -->
    <vs-popup title="Información del Proveedor" :active.sync="showFormPromptSupplierInfo">
      <supplier-details v-if="currentSupplierID !== null" ref="supplierDetails" :supplier_id="currentSupplierID"></supplier-details>
    </vs-popup>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { humanDateFilter } from "./admin/filters/humanDateFilter";
import { diffDays } from "./admin/filters/diffDays";
import SupplierDetails from "../../src/views/admin/projects/process-flow/SupplierDetails.vue"
import SupplierAgentInformation from "@projects/SupplierAgentInformation";
import dateHelper from "./mixins/dateHelper";
import projectStatusesHelper from "./mixins/projectStatusesHelper";
import LoanScreenedButton from "./project-details/LoanScreenedButton.vue";

export default {
  name: "projects-request-list",
  mixins: [dateHelper, projectStatusesHelper],
  props: {
    isProjectModule: {
      type: Boolean,
      default: true
    },
    filters: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    variant: String,
    order: String,
  },
  components: {
    SupplierDetails
    , SupplierAgentInformation
    , LoanScreenedButton
  },
  filters: {
    humanDate: humanDateFilter,
    diffDays: diffDays,
  },
  data() {
    return {
      current_page: 1,
      mutableOrder: _.clone(this.order),
      mutableFilters: _.clone(this.filters),
      mutableApproveStatus: "",
      projects: [],
      term: "",

      PM_CLIENT_TYPE: 0,
      PF_CLIENT_TYPE: 1,
      PFAE_TAX_PROFILE: 1,
      itemsPerPage: 10,

      isMounted: false,
      itemsPerPageDefinitions: [10, 15, 20, 30, 50],
      currentItemsPage: 0,
      popupActivo: false
      , currentLead: null
      , currentSupplierID: null
      , showFormPromptSupplierInfo: false
    };
  },
  watch: {
    async term() {
      // await this._findProjects();
    },
    async filterStatus() {
      await this._findProjects();
    },
    async mutableOrder() {
      await this._findProjects();
    },
    async "mutableFilters.approved_status"() {
      await this._findProjects();
    },
  },
  async mounted() {
    await this._findProjects();
    this.isMounted = true;
  },
  computed: {
    ...mapState("projects", ["orderOptions", "status", "revisionStatus"]),
    async filterStatus() {
      return this.mutableFilters["projects.status"];
    },
    currentPage: {
      get: function () {
        if (this.isMounted) {
          return this.$refs.table.currentx;
        }
        return 0;
      },
      set: function (val) {
        this.$refs.table.currentx = val;
      }
    },
    getTotalPages() {
      return Math.ceil(this.projects.length / this.itemsPerPage);
    },
  },
  methods: {
    ...mapActions("projects", ["findProjectRequests"]),
    async _findProjects() {
      this.$vs.loading();

      let params = {
        page: this.current_page,
        term: this.term,
        filters: this.mutableFilters,
        order: this.mutableOrder,
      };

      const projs = await this.findProjectRequests(params);
      this.$vs.loading.close();

      let projects = [];
      projs.forEach(proj => {
        projects.push({
          id: proj.body.id,
          alias: proj.body.alias,
          tradename: proj.body.tradename,
          tt: proj.tt,
          light: proj.light,
          client: proj.body.client_id + " | " + proj.body.fiscal_name,
          email: proj.body.client.user.email,
          status: proj.body.status,
          statusStr: proj.body.status_named,
          phone: this.getPhone(proj.body.client.user),
          sid: proj.body.sid,
          type: this.clientPersonType(proj.body),
          pgmApplicant: proj.body.pgm_potential_applicant,
          credit_request_events: proj.body.credit_request_events,
          documentation_complete_date: proj.body.documentation_complete_date,
          loan_review_request_timestamp: proj.body.loan_review_request_timestamp,
          loan_proposal_timestamp: proj.body.loan_proposal_timestamp,
          credit_acceptance_date: proj.body.credit_acceptance_date,
          loan_request_step: proj.body.loan_request_step,
          case: proj.body.case,
          loan_type: proj.body.loan_type,
          application_screened_at: proj.body.application_screened_at , 
          credit_risk_responsible: proj.body.credit_risk_responsible , 
          origination_responsible: proj.body.origination_responsible ,
          review_date: proj.body.review_date
        });
      });

      this.projects = projects;
      this.currentPage = 1;
    },
    updateItemsPerPage(it) {
      this.itemsPerPage = it;
      this.currentPage = 1;
    },
    async refreshTable() {
      await this._findProjects();
    },
    async cleanTerm() {
      this.term = null;
      await this._findProjects();
    },
    async handleSelected(proj) {
      if (this.isProjectModule) {
        window.open(`/project/${proj.id}`, '_blank');
      } else {
        window.open(`/risk-model/expediente/${proj.id}`, '_blank');
      }
    },
    async handleDblSelected(proj) {
      await this.$router.push(`/project/${proj.id}`);
    },
    clientPersonType(proj) {
      if (proj.client.user.person_type === this.PM_CLIENT_TYPE) {
        return "PM";
      } else {
        return proj.client.user.personal.tax_profile === this.PFAE_TAX_PROFILE ? "PFAE" : "PF";
      }
    },
    clientTypeColor(type) {
      if (type === 'PF') {
        return "#1976d2";
      } else if (type === 'PM') {
        return "#7e57c2";
      } else {
        return "#24c1a0";
      }
    },
    statusColor(status) {
      if (status === 2) {
        return "#7cb342";
      } else if (status === 3) {
        return "#4dd0e1";
      } else {
        return "#8bc34a";
      }

    },
    getZone(pgmApplicant) {
      if(pgmApplicant.subregion_manager_id !== null 
      && pgmApplicant.subregion_manager.region_manager_id !== null
      && pgmApplicant.subregion_manager.region_manager.zone_manager_id !== null
      && pgmApplicant.subregion_manager.region_manager.region !== null
      && pgmApplicant.subregion_manager.region_manager.region.zone !== null
      ){
        return pgmApplicant.subregion_manager.region_manager.region.zone.name;
      }
    },
    getRegion(pgmApplicant) {
      if(pgmApplicant.subregion_manager_id !== null 
      && pgmApplicant.subregion_manager.region_manager_id !== null
      && pgmApplicant.subregion_manager.region_manager.region !== null
      ){
        return pgmApplicant.subregion_manager.region_manager.region.name;
      }
    },
    getPhone(user) {
      let phone;
      if(user.personal) {
        phone = `${user.personal.country_calling_code} ${user.personal.new_phone}`;
      } else {
        phone = `${user.business.country_calling_code} ${user.business.new_phone}`;
      }
      return phone;
    },
    showSupplierInformation(sid){
      this.currentSupplierID = sid;
      this.showFormPromptSupplierInfo = true;
      this.$refs.supplierDetails.update(sid);
      this.$refs.supplierDetails.getSupplierAgents(sid);
    }
  },
};
</script>

<style scoped>
.light {
  height: 25px;
  width: 25px;
  border-radius: 50%;
}

.light.l-0 {
  background-color: rgba(var(--vs-success), 1);
}

.light.l-1 {
  background-color: rgba(var(--vs-warning), 1);
}

.light.l-2 {
  background-color: rgba(var(--vs-danger), 1);
}

.con-vs-chip {
  font-size: 0.75rem !important;
}

.con-vs-chip.extended {
  font-size: 0.9rem !important;
}

.colored {
  color: rgba(var(--vs-primary), 1);
}

.con-select {
  margin-top: 1.1rem !important;
}

.input-select-con input {
  height: 3.5rem !important;
}
</style>
